export interface ITestResult {
    resultId: number;
    testId: number;
    patientId: number;
    dtTest: Date;
    dtRegister: Date;
    value: number;
    notes: string;
}
